import { __, Alert } from "modules/theme";
import React, { Component } from "react";
import PropTypes from "prop-types";
import APIManager from "modules/common/apiManager";
import {
  FormControl,
  FormGroup,
  ControlLabel,
  ModalFooter,
  Button,
  ButtonCommonTheme,
} from "modules/theme";
import { FormWrapper, FormColumn } from "modules/theme";
import {
  ModalForm,
  ModalFormContainer,
} from "../../../../theme";
import Select from "react-select-plus";
import { isAccess } from "../../../../common/utils";
import CommonManager, { debounce } from "../../../../../helpers/common";
import Creatable from "react-select-plus/lib/Creatable";
import SelectFilterAPI from "../../../../common/components/form/SelectFilterAPI";

const commonManager = new CommonManager();

export class LLMModelAddEdit extends Component {
  constructor(props) {
    super(props);
    this.moduleName = `LLM Model`;
    this.moduleUrl = `config/llm`;
    this.saveData = this.saveData.bind(this);
    this.renderFormGroup = this.renderFormGroup.bind(this);
    this.mAPI = new APIManager();
    this.setData(this.props.editData);
  }
  setData(editData = {}) {
    editData = editData || {};
    this.state = {
      isLoading: false,
      // provider: editData.provider || "",
      provider:
        editData &&
        Array.isArray(editData.provider) &&
        editData.provider.length > 0
          ? editData.provider[0]._id
          : null,
      initialProvider: (editData && editData.provider) || [],
      key: editData.key || "",
      label: editData.label || "",
      maxTokens: editData.maxTokens || 0,
    };
  }

  renderFormGroup(label, props) {
    return (
      <FormGroup>
        <ControlLabel required={props.required}>{label}</ControlLabel>
        <FormControl {...props} />
      </FormGroup>
    );
  }

  resetAllData() {
    this.setState({
      provider: "",
      key: "",
      value: "",
      maxTokens: 0,
      deprecated: false,
    });
  }

  apiResponse(errorCode, data) {
    if (errorCode === 201) {
      // Alert.success(`${data.message}`);
      let message = data && data.message ? data.message : "Successfully Done";
      Alert.success(`${message}`);
      this.resetAllData();
      this.props.closeModal(true);
    } else {
      // Alert.error(`${data.message}`);
      let message =
        data && data.message ? data.message : "Something wrong happened";
      Alert.error(`${message}`);
      this.setState({ isLoading: false });
    }
  }

  saveData(e) {
    e.preventDefault();
    this.setState({ isLoading: true });
    let _this = this;
    let tData = {
      provider: this.state.provider,
      key: this.state.key,
      label: this.state.label,
      maxTokens: parseInt(this.state.maxTokens),
    };
    if (this.props.editData && this.props.editData._id) {
      this.mAPI.sendPostAPI(
        `${this.moduleUrl}/${this.props.editData._id}`,
        tData,
        (data) => {
          console.log(JSON.stringify(data, null, 2));
          if (data) {
            _this.resetAllData();
            _this.props.closeModal(true);
            Alert.success(`${this.moduleName} updated successfully.`);
            this.setState({ isLoading: false });
          }
        },
        (errorCode, data) => {
          this.apiResponse(errorCode, data);
        },
        "public",
        { id: this.props.editData._id },
        "PATCH"
      );
    } else {
      this.mAPI.sendPostAPI(
        `${this.moduleUrl}`,
        tData,
        (data) => {
          _this.setData();
          _this.props.update();
          _this.props.closeModal(true);
          Alert.success(`${this.moduleName} created successfully.`);
          _this.setState({ isLoading: false });
        },
        (errorCode, data) => {
          this.apiResponse(errorCode, data);
          _this.setState({ isLoading: false });
        },
        "public"
      );
    }
  }

  render() {
    const { modalType } = this.props;
    console.log(
      "this.state.provider, this.state.initialProvider",
      this.state.provider,
      this.state.initialProvider
    );
    return (
      <ModalForm onSubmit={(e) => this.saveData(e)}>
        <ModalFormContainer>
          <FormWrapper>
            <FormColumn>
              <FormGroup>
                <ControlLabel required>Provider</ControlLabel>
                <SelectFilterAPI
                  dataUrl={"config/llm/provider"}
                  global={true}
                  selected={this.state.provider}
                  initialValues={commonManager.initialData(
                    this.state.initialProvider,
                    "name",
                    "_id"
                  )}
                  dataValue={"key"}
                  dataLabel={"label"}
                  label={"Provider"}
                  multi={false}
                  required={true}
                  onSelect={(items, name, ops) => {
                    if (items) {
                      this.setState({
                        provider: items,
                        initialProvider: commonManager.selectedSingleData(
                          items,
                          ops
                        ),
                      });
                    } else {
                      this.setState({
                        provider: null,
                      });
                    }
                  }}
                />
              </FormGroup>
            </FormColumn>
          </FormWrapper>
          <FormWrapper>
            <FormColumn>
              {this.renderFormGroup("Display Name", {
                defaultValue: "",
                placeholder: "Display Name",
                autoFocus: false,
                required: true,
                id: "displayName",
                value: this.state.label,
                onChange: (e) => {
                  if (e.target.value === " ") {
                    return false;
                  }
                  this.setState({
                    label: e.target.value,
                  });
                },
              })}
            </FormColumn>
          </FormWrapper>
          <FormWrapper>
            <FormColumn>
              {this.renderFormGroup("Key", {
                defaultValue: "",
                placeholder: "Key",
                autoFocus: false,
                required: true,
                id: "key",
                disabled:
                  this.props.editData && this.props.editData._id ? true : false,
                value: this.state.key,
                onChange: (e) => {
                  if (e.target.value === " ") {
                    return false;
                  }
                  this.setState({
                    key: e.target.value,
                  });
                },
              })}
            </FormColumn>
          </FormWrapper>
          <FormWrapper>
            <FormColumn>
              {this.renderFormGroup("Max Tokens", {
                defaultValue: "",
                placeholder: `Enter token`,
                autoFocus: false,
                disabled: this.state.disabled,
                required: true,
                id: "maxTokens",
                // maxLength: this.state.maxTokenLimit,
                value: this.state.maxTokens,
                onChange: (e) => {
                  let re = /^(\s*|\d+)$/;
                  const newValue = e.target.value;
                  if (
                    !re.test(newValue) ||
                    // Number(newValue) > this.state.maxTokenLimit ||
                    newValue === " "
                  ) {
                    return false;
                  }
                  this.setState({
                    maxTokens: newValue,
                  });
                },
              })}
            </FormColumn>
          </FormWrapper>
        </ModalFormContainer>
        <ModalFooter modalType={modalType}>
          <ButtonCommonTheme
            type="greyModalBtn"
            // btnStyle="cancel"
            OnClick={() => this.props.closeModal()}
            size="xl"
            modalBtnTitle="Cancel"
          />
          <ButtonCommonTheme
            type="blueModalBtn"
            btnType="submit"
            isLoading={this.state.isLoading}
            disabled={this.state.isLoading}
            modalBtnTitle={
              this.props.editData && this.props.editData._id ? "Update" : "Add"
            }
          />
        </ModalFooter>
      </ModalForm>
    );
  }
}

LLMModelAddEdit.propTypes = {
  group: PropTypes.array,
};

LLMModelAddEdit.contextTypes = {
  __: PropTypes.func,
  closeModel: PropTypes.func.isRequired,
};

export default LLMModelAddEdit;



// WEBPACK FOOTER //
// src/modules/screens/Org_setting/LLMModel/components/LLMModelAddEdit.js